<template>
  <div class="sub-com-wrap">

    <header class="header-wrap">
      <div class="icon">
        <el-icon color="#FFFFFF" size="40">
          <User/>
        </el-icon>
      </div>
      <h5>{{ enterpriseInfo.name }}</h5>
    </header>

    <div class="block">
      <div class="title">
        <div class="sep"></div>
        基本信息
      </div>

      <el-row class="info-row" :gutter="30">
        <el-col :span="5" class="info-label right">统一社会信用代码</el-col>
        <el-col :span="6" class="info-label">{{ enterpriseInfo.creditCode }}</el-col>
        <el-col :span="5" class="info-label right">纳税人状态</el-col>
        <el-col :span="5" class="info-label">正常</el-col>
      </el-row>

      <el-row class="info-row" :gutter="30">
        <el-col :span="5" class="info-label right">纳税人名称</el-col>
        <el-col :span="6" class="info-label">{{ enterpriseInfo.name }}</el-col>
        <el-col :span="5" class="info-label right">主管税务机构</el-col>
        <el-col :span="5" class="info-label">北京东城区税务局</el-col>
      </el-row>

      <el-row class="info-row" :gutter="30">
        <el-col :span="5" class="info-label right">生产经营地址</el-col>
        <el-col :span="10" class="info-label">{{ enterpriseInfo.address }}</el-col>
      </el-row>
    </div>

    <div class="block">
      <div class="title">
        <div class="sep"></div>
        人员信息
      </div>

      <el-row class="info-row" :gutter="30">
        <el-col :span="5" class="info-label right">法定代表人姓名</el-col>
        <el-col :span="6" class="info-label">{{ 'admin' }}</el-col>
        <el-col :span="5" class="info-label right">财务负责人名称</el-col>
        <el-col :span="5" class="info-label">admin</el-col>
      </el-row>

      <el-row class="info-row" :gutter="30">
        <el-col :span="5" class="info-label right">法定代表人手机号码</el-col>
        <el-col :span="6" class="info-label">{{ '010-64278838' }}</el-col>
        <el-col :span="5" class="info-label right">财务负责人手机号</el-col>
        <el-col :span="5" class="info-label">010-64278838</el-col>
      </el-row>

      <el-row class="info-row" :gutter="30">
        <el-col :span="5" class="info-label right">生产经营地址</el-col>
        <el-col :span="10" class="info-label">{{ enterpriseInfo.address }}</el-col>
      </el-row>

    </div>
  </div>
</template>

<script setup>
const enterpriseInfo = ref({
  name: '北京仁和服饰有限公司',
  creditCode: '91110104533585261H',
  address: '北京市东城区和平里东街3号',

})
</script>

<style scoped lang="scss">
.sub-com-wrap {
  height: 100%;

  .header-wrap {
    display: flex;
    align-items: center;
    padding: 20px;
    background: #FFFFFF;

    .icon {
      width: 60px;
      height: 60px;
      background-color: #409eff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    > h5 {
      font-size: 20px;
      font-weight: 600;
      margin-left: 10px;
    }
  }

  .block {
    margin-top: 20px;
    background-color: #FFFFFF;
    padding: 20px 0;

    .title {
      font-size: 20px;
      line-height: 30px;
      color: #303133;
      font-weight: 700;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ebeef5;
      padding: 0 20px 20px 20px;
      margin-bottom: 20px;

      .sep {
        width: 5px;
        background-color: #409eff;
        margin-right: 8px;
        height: 20px;
        border-radius: 20%;
      }
    }

    .info-row {
      margin: 0 20px !important;
      border-bottom: 1px solid #ebeef5;

      .info-label {
        line-height: 50px;

        &.right {
          text-align: right;
        }
      }
    }


  }

}
</style>
